<div class="terms">
  <h2>{{ "main.terms.title" | translate }}</h2>
  <div class="row terms-block">
    <div
      class="col-lg-4 col-md-6 col-sm-12 terms-item"
      *ngFor="let _ of [].constructor(stepIndexes); index as i"
    >
      <div class="terms-item-text">
        <div class="step-number">
          {{ "main.terms.steps.step-" + (i + 1) + ".numbering" | translate }}
        </div>
        <h5>
          {{ "main.terms.steps.step-" + (i + 1) + ".title" | translate }}
        </h5>
        <p>
          {{ "main.terms.steps.step-" + (i + 1) + ".description" | translate }}
        </p>
      </div>
    </div>
    <div class="col-lg-8 col-md-6 col-sm-12 terms-item m-0">
      <div class="terms-item-text">
        <div class="step-number">
          {{ "main.terms.steps.step-" + (stepIndexes + 1) + ".numbering" | translate }}
        </div>

        <h5>
          {{
            "main.terms.steps.step-" + (stepIndexes + 1) + ".title" | translate
          }}
        </h5>
        <p>
          {{
            "main.terms.steps.step-" + (stepIndexes + 1) + ".description"
              | translate
          }}
        </p>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <button class="contact-btn" (click)="goTo('contacts')">
        {{ "main.terms.cta-btn" | translate }}
      </button>
    </div>
  </div>
</div>
